import "vuetify/styles/core"
import { createVuetify } from "vuetify"
import { createVueI18nAdapter } from "vuetify/locale/adapters/vue-i18n"
import { useI18n } from "vue-i18n"
import DateFnsAdapter from "@date-io/date-fns"
import { enUS as en } from "date-fns/locale/en-US"
import { fr } from "date-fns/locale/fr"
import * as components from "vuetify/components"
import * as directives from "vuetify/directives"
import { BLUE_THEME, AQUA_THEME, PURPLE_THEME, GREEN_THEME, CYAN_THEME, ORANGE_THEME } from "@/theme/LightTheme"
import {
  DARK_BLUE_THEME,
  DARK_AQUA_THEME,
  DARK_ORANGE_THEME,
  DARK_PURPLE_THEME,
  DARK_GREEN_THEME,
  DARK_CYAN_THEME,
} from "@/theme/DarkTheme"
import i18n from "@/utils/i18n"

export default createVuetify({
  components,
  directives,
  date: {
    adapter: DateFnsAdapter,
    locale: {
      en: en,
      fr,
    },
  },
  locale: {
    adapter: createVueI18nAdapter({ i18n, useI18n }),
    locale: "fr",
    fallback: "en",
  },
  theme: {
    defaultTheme: "BLUE_THEME",
    themes: {
      BLUE_THEME,
      AQUA_THEME,
      PURPLE_THEME,
      GREEN_THEME,
      CYAN_THEME,
      ORANGE_THEME,
      DARK_BLUE_THEME,
      DARK_AQUA_THEME,
      DARK_ORANGE_THEME,
      DARK_PURPLE_THEME,
      DARK_GREEN_THEME,
      DARK_CYAN_THEME,
    },
  },
  defaults: {
    VCard: {
      rounded: "md",
    },
    VTextField: {
      variant: "outlined",
      density: "comfortable",
      color: "primary",
    },
    VTextarea: {
      variant: "outlined",
      density: "comfortable",
      color: "primary",
    },
    VSelect: {
      variant: "outlined",
      density: "comfortable",
      color: "primary",
    },
    VListItem: {
      minHeight: "45px",
    },
    VTooltip: {
      location: "top",
    },
  },
})
